import Vue from 'vue'

import "@/global/index_jobfair"

// 引入该页面个性化UI组件
import {
    Card, Image
} from 'element-ui';

Vue.use(Card)
Vue.use(Image)

import store from '@/store/global-store'
import App from './App'
new Vue({
    store,
    render: h => h(App),
    created: function () {

    }
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/seeker/job/detail/jobfair_job.js